import type { Prototype } from "../prototype-types";

export const ericDingPrototypes: Prototype[] = [
  {
    id: "ed-brand-cart-minimum-completion",
    name: "Brand Cart Minimum Completion",
    path: "/ed/brand-cart-minimum-completion",
    description: "Helps retailers close a brand cart's order-minimum gap: an inline gap-closer rail with exact-fit quantities, plus context on why the brand sets a minimum.",
    owner: "Eric Ding",
    createdAt: "2026-08-23",
    lastUpdated: "2026-08-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.faire.com/fastly/408a9357a8209ef9f4483cf357b538dd87d108b94b2726480f09ecc31f0e4e7a.png",
    creationTool: "claude-code",
  },
  {
    id: "ed-brand-page-side-cart-minimum",
    name: "Brand Page Side Cart Minimum",
    path: "/ed/brand-page-side-cart-minimum",
    description: "Brand-page side cart with the order-minimum meter moved into the summary footer and Complete your cart replaced by exact-fit gap closers.",
    owner: "Eric Ding",
    createdAt: "2026-08-23",
    lastUpdated: "2026-08-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.faire.com/fastly/7dfca273b1d42d7212b040c7c1526abb5569c359e9c1fd89d07de935bfbbdc4c.png",
    creationTool: "claude-code",
  },
  {
    id: "ed-first-order-minimum-opportunity",
    name: "First Order Minimum Opportunity",
    path: "/ed/first-order-minimum-opportunity",
    description: "Brand-side settings nudge: quantifies the carts and GMV stopped just short of a brand's first-order minimum, and simulates what lowering it to match the reorder minimum would recover.",
    owner: "Eric Ding",
    createdAt: "2026-08-26",
    lastUpdated: "2026-08-26",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.faire.com/fastly/46234b3aa7648ab27bff7ea50fd0a904469496f2d653a35ceede8191faac43ce.png",
    creationTool: "claude-code",
  },
  {
    id: "ed-product-tile-cart-peek",
    name: "Product Tile Cart Peek",
    path: "/ed/product-tile-cart-peek",
    description: "Cart icon beside the brand name on home and search product tiles: hover reveals a cart summary with minimum progress, click opens the brand side cart.",
    owner: "Eric Ding",
    createdAt: "2026-08-28",
    lastUpdated: "2026-08-28",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.faire.com/fastly/39d2ffe6d0f0a0874f2a4757ac42f4100951558a67e9037673074fc9e08b0d09.png",
    creationTool: "claude-code",
  },
  {
    id: "ed-post-order-discovery",
    name: "Post-Order Discovery",
    path: "/ed/post-order-discovery",
    description: "Order confirmation banner that sends retailers into a personalized discovery rail: 50 percent off waiting from new brands, landing on products similar to the brand they just ordered from.",
    owner: "Eric Ding",
    createdAt: "2026-09-01",
    lastUpdated: "2026-09-01",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.faire.com/fastly/1dd9ae81154889b4188e01254381fa2bffea835fbb8ccca66e8b298742b9d6ad.png",
    creationTool: "claude-code",
  }
];
